export default {
    it: {
        "title": "Domanda inoltrata",
        

    },
    en: {
        "title": "Application submitted",
        
    }
}